//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateEmail } from "@/utils/validations.js";
import BackendServices from "@/services/backend-services";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "UserManagementForm",
  components: {},
  props: ["selectedRow", "drawerMode"],
  mounted: async function () {
    this.formLoading = true;
    await BackendServices.getDepartments().then((response) => {
      this.availableDepartments = response.data;
    });

    await BackendServices.getRolesList().then((response) => {
      this.availableRoles = response.data;
    });
    this.formLoading = false;
    this.updateForm();
  },
  data() {
    return {
      validForm: false,
      email: "",
      name: "",
      department: "",
      departmentId: "",
      role: "",
      roleId: "",
      availableDepartments: [],
      availableRoles: [],
      formLoading: false,
      state: "",
    };
  },
  methods: {
    required,
    noValidation,
    validateEmail,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      this.$emit("save-user", {
        newUser: {
          id: this.selectedRow.id,
          email: this.email,
          name: this.name,
          department: this.availableDepartments.find(
            (department) => department.id === this.departmentId
          ).name,
          department_id: this.departmentId,
          role: this.availableRoles.find((role) => role.id === this.roleId)
            .name,
          role_id: this.roleId,
        },
      });
    },
    updateForm() {
      this.email = this.selectedRow.email;
      this.name = this.selectedRow.name;
      this.department = this.selectedRow.department;
      this.departmentId = this.selectedRow.department_id;
      this.role = this.selectedRow.role;
      this.roleId = this.selectedRow.role_id;
      this.state = this.selectedRow.state;
    },
    blockUser() {
      this.$emit("block-reg", {
        newUser: {
          id: this.selectedRow.id,
          email: this.email,
          name: this.name,
          department: this.availableDepartments.find(
            (department) => department.id === this.departmentId
          ).name,
          department_id: this.departmentId,
          role: this.availableRoles.find((role) => role.id === this.roleId)
            .name,
          role_id: this.roleId,
        },
      });
    },
    deleteUser() {
      this.$emit("delete-reg", {
        newUser: {
          id: this.selectedRow.id,
          email: this.email,
          name: this.name,
          department: this.availableDepartments.find(
            (department) => department.id === this.departmentId
          ).name,
          department_id: this.departmentId,
          role: this.availableRoles.find((role) => role.id === this.roleId)
            .name,
          role_id: this.roleId,
        },
      });
    },
    async resetPassword() {
      let response = await BackendServices.resetPassword({
        email: this.email
      });
      if (response.status === 200) {
        Feedback.success(response.data.message);
      } else {
        Feedback.error(response.data.message);
      }

    },
  },
  //TODO Meter eficientemente os dados
  watch: {
    email() {
      this.updateData();
    },
    name() {
      this.updateData();
    },
    departmentId() {
      this.updateData();
    },
    roleId() {
      this.updateData();
    },
    selectedRow() {
      this.updateForm();
    },
  },
  computed: {
    isSelf() {
      return this.selectedRow.id == parseInt(this.$store.getters.userId);
    },
  },
};
